import imageCompression from 'browser-image-compression';
export type compressionOptions = {
    maxSizeMB: number, // Maximum size in kb (500kb)
    maxWidthOrHeight: number, // Maximum width or height in pixels
    useWebWorker: boolean
}
const compressionOption: compressionOptions = {
    maxSizeMB: 0.5, // Maximum size in kb (500kb)
    maxWidthOrHeight: 1024, // Maximum width or height in pixels
    useWebWorker: true
}
export default async function imageCompresser(file: File, maxSizeMB?: number | null) {
    if (!file) {
        return null
    }
    const options = {
        ...compressionOption,
        ...(maxSizeMB ? { maxSizeMB } : {})

    }
    const compressedFile = await imageCompression(file, { ...options, maxSizeMB });
    return compressedFile
}
